import { action, observable } from 'mobx';
import { RootStore } from 'stores/rootStore';
import { ApiStore } from 'stores/apiStore';
import { API_ACCOUNT_DETAIL_SIGNED_DOCUMENTS, ADMIN_SIGNED_DOCUMENTS } from 'api/endpoints';

export interface DocumentData {
  filename: string;
  id: string;
  loading?: boolean;
}

export class SignedDocumentsStore {
  rootStore: RootStore;
  accountId: string;
  apiStore: ApiStore;
  backoffice: boolean;
  @observable error = false;
  @observable data: DocumentData[] | null;

  constructor(rootStore: RootStore, accountId: string, backoffice?: boolean) {
    this.rootStore = rootStore;
    this.accountId = accountId;
    this.apiStore = rootStore.stores.apiStore;
    this.data = null;
    this.backoffice = !!backoffice;
  }

  @action fetchData = async (boAccountId?: string) => {
    const response = await this.apiStore.get<DocumentData[]>(
      this.backoffice
        ? ADMIN_SIGNED_DOCUMENTS(boAccountId)
        : API_ACCOUNT_DETAIL_SIGNED_DOCUMENTS(this.accountId),
    );
    if (response?.data) {
      this.error = false;
      this.data = response.data.map((doc: DocumentData) => {
        doc.loading = false;
        return doc;
      });
    } else {
      this.error = true;
    }
  };

  @action downloadDocument = async (document: DocumentData, boAccountId?: string) => {
    this.setLoadingForDocument(document, true);
    await this.apiStore.get(
      `${this.backoffice ? '/bo' : ''}/account/${boAccountId || this.accountId}/pdf/download/${
        document.id
      }?filename=${document.filename}`,
    );
    this.setLoadingForDocument(document, false);
  };

  @action
  setLoadingForDocument = (document: DocumentData, loading: boolean) => {
    this.data = this.data!.map((doc) => {
      if (doc.id === document.id) {
        doc.loading = loading;
      }
      return doc;
    });
  };
}
